import React, { useState } from 'react'
import { COUNTRY_CODES } from 'src/screens/countryCodes'

// Country code dropdown (Kenya +254 by default) plus the local number.
// onChange receives the full number as digits, e.g. 254712345678, or "" while empty.
const PhoneInput = ({ onChange, required, id, className = 'custom-input', placeholder = '7XX XXX XXX' }) => {
    const [code, setCode] = useState('254')
    const [local, setLocal] = useState('')

    function emit(nextCode, nextLocal) {
        const digits = nextLocal.replace(/\D/g, '').replace(/^0+/, '')
        onChange(digits ? nextCode + digits : '')
    }

    return (
        <div style={{ display: 'flex', gap: 8 }}>
            <select
                className={className}
                style={{ flex: '0 0 112px', width: 112, paddingLeft: 8, paddingRight: 4 }}
                value={code}
                onChange={(e) => {
                    setCode(e.target.value)
                    emit(e.target.value, local)
                }}
            >
                {COUNTRY_CODES.map((country) => (
                    <option key={country.code} value={country.code} title={country.label}>{country.label.replace(/\s*\(.*\)/, '')}</option>
                ))}
            </select>
            <input
                id={id}
                type="tel"
                className={className}
                required={required}
                value={local}
                placeholder={placeholder}
                onChange={(e) => {
                    setLocal(e.target.value)
                    emit(code, e.target.value)
                }}
            />
        </div>
    )
}

export default PhoneInput
